import { render } from "./HelpSupport.vue?vue&type=template&id=cd73a628"
import script from "./HelpSupport.vue?vue&type=script&lang=js"
export * from "./HelpSupport.vue?vue&type=script&lang=js"
script.render = render

export default script